<template>
  <b-form @submit.prevent>
    <b-row>
      <b-col md="6">
        <b-form-group
            label="ID Avito"
            label-for="avito_id"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.avito_id}"
              v-model="city.avito_id"
              id="avito_id"
              placeholder="ID Avito"
          />
          <small v-if="form_errors.avito_id" class="text-danger">{{ form_errors.avito_id[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="Nom"
            label-for="libelle"
        >
          <b-form-input
              :class="{'is-invalid' : form_errors.libelle}"
              v-model="city.libelle"
              id="libelle"
              placeholder="Nom de la ville"
          />
          <small v-if="form_errors.libelle" class="text-danger">{{ form_errors.libelle[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            @click="submit"
        >
          Enregistrer
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'AvitoCityForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    initialCity: {
      default: false,
    }
  },
  methods: {
    submit() {
      let _this = this;
      _this.form_errors = {};
      
      const action = this.city.id 
        ? 'siteModule/updateAvitoCity'
        : 'siteModule/storeAvitoCity';
      
      this.$store.dispatch(action, this.city).then(function (response) {
        _this.$emit('submitted', response);
        _this.$router.push('/avito-cities');
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          _this.form_errors = error.response.data.errors;
        }
      });
    }
  },
  created() {
    this.city = this.initialCity ? {...this.initialCity} : {
      avito_id: '',
      libelle: ''
    };
  },
  data() {
    return {
      city: {
        avito_id: '',
        libelle: ''
      },
      form_errors: {}
    }
  },
}
</script>
